<div class="w-full px-4">
    <div class="w-full flex flex-column gap-3">
        <div class="grid">
            <h1 class="text-left col-10 font-bold text-4xl">Admin Manager</h1>
            <p-button icon="pi pi-user-plus" (click)="showDialog()" label="Add Admin" class="col-2 flex flex-column gap-1" styleClass="submitBtn" />
        </div>
      <div class="w-full flex flex-column gap-2 py-4 px-3 bg-white border-round-2xl shadow-2">
        <h2 class="text-left font-medium text-2xl" style="color: #303030;">Search</h2>
        <form [formGroup]="filterForm" (ngSubmit)="getAdmins(1)" class="w-full flex flex-wrap">
          <div class="w-full grid">
            <div class="col-2 flex flex-column gap-1">
              <b class="font-regular text-base" style="color: #505050;">From Date</b>
              <p-calendar placeholder="From date" formControlName="fromDate" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay"
                class="w-full" styleClass="fullWidth" />
            </div>
            <div class="col-2 flex flex-column gap-1">
              <b class="font-regular text-base" style="color: #505050;">To Date</b>
              <p-calendar placeholder="To Date" formControlName="toDate" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay"
                class="w-full" styleClass="fullWidth" />
            </div>
            <div class="col-3 flex flex-column gap-1">
              <b class="font-regular text-base" style="color: #505050;">Organization</b>
              <input placeholder="Name" type="text" formControlName="organization" pInputText class="w-full" />
            </div>
            <div class="col-3 flex flex-column gap-1">
              <b class="font-regular text-base" style="color: #505050;">State</b>
              <p-dropdown [options]="adminStateOptions" styleClass="selectFull" class="w-full" optionLabel="name"
                optionValue="value" formControlName="adminState" filterBy="name" [showClear]="true"
                appendTo="body" placeholder="Select Admin-State">
                <ng-template pTemplate="selectedItem" let-selectedOption>
                  <div class="flex align-items-center gap-2">
                    <div>{{ selectedOption.name }}</div>
                  </div>
                </ng-template>
                <ng-template let-option pTemplate="item">
                  <div class="flex align-items-center gap-2">
                    <div>{{ option.name }}</div>
                  </div>
                </ng-template>
              </p-dropdown>
            </div>
            <div class="col-2">
              <div class="w-full" style="padding-top: 23px;">
                <p-button type="submit" label="Search" class="w-full" styleClass="submitBtn" />
              </div>
            </div>
        </div>
      </form>
      </div>

      <div class="w-full">
        <p-table  *ngIf="adminList && adminList.length > 0; else noRecordsFound" [value]="adminList"
          [paginator]="adminList.length!=totalRecords" [rows]="rowSize" [showCurrentPageReport]="true" [alwaysShowPaginator]="true" [totalRecords]="totalRecords" [first]="first" [lazy]="true"
          [lazyLoadOnInit]="false" [loading]="isLoading" [loadingIcon]="'pi pi-spinner'"
          (onLazyLoad)="onLazyLoad($event)" [rowsPerPageOptions]="[10, 20, 30]" [showPageLinks]="true"
          styleClass="p-datatable-gridlines tableCon" [tableStyle]="{ 'min-width': '50rem' }">
          <ng-template pTemplate="header">
            <tr>
              <th>Admin Name</th>
              <th>Gender</th>
              <th>Email</th>
              <th>Phone Number</th>
              <th>Organization Name</th>
              <th>Website</th>
              <th>Toggle State</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-admin>

            <tr>
              <td>{{admin.firstName}} {{admin.lastName}}</td>
              <td>{{genderDescriptions(admin.gender)}}</td>
              <td>{{admin.email}}</td>
              <td>{{admin.phoneNumber}}</td>
              <td>{{admin.organizationName}}</td>
              <td>{{admin.website}}</td>
              <td>
                <p-toggleButton

                [ngModel]="admin.state === AdminState.Active"
                (onChange)="onAdminStatusChange($event,admin)"
                onLabel="Active"
                offLabel="Inactive"
                [onIcon]="'pi pi-check'"
                offIcon="pi pi-times"
                styleClass="w-9rem toggleBtn"
                ariaLabel="Do you confirm" />
                <!-- <p-button (onClick)="showDialog(admin)" label="Edit Admin" icon="pi pi-user-edit" styleClass="viewapplication" /> -->
              </td>
            </tr>
          </ng-template>
        </p-table>
        <ng-template #noRecordsFound>
          <div class="w-full flex flex-column align-items-center py-4 gap-5">
            <div class="w-full flex align-items-center justify-content-center">
              <img src="../../../assets/icons/nodatafound.svg" alt="" class="w-full max-w-16rem">
            </div>
            <b class="text-center font-normal text-2xl" style="color: #000086;">No Data Found !</b>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <p-dialog header="New Admin" [(visible)]="isVisible" [modal]="true" [style]="{ width: '70rem' }">
    <div class="w-full ">
        <div class="w-full flex flex-column gap-3">
            <form (ngSubmit)="addAdmin()" [formGroup]="newAdminForm">
                <div class="w-full flex flex-column gap-2 ">
                    <h2 class="text-left text-xl font-medium px-2" style="color: #101011;">Admin Information</h2>
                    <div class="w-full flex flex-wrap">
                        <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                            <b class="text-left font-normal text-base" style="color: #424242;">First Name</b>
                            <input pInputText formControlName="firstName" type="text" class="inputField">
                            <small class="ng-dirty ng-invalid text-red-500"
                                *ngIf="newAdminForm.get('firstName')?.invalid && (submitted || newAdminForm.get('firstName')?.touched)">
                                First Name is required
                            </small>
                        </div>
                        <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                            <b class="text-left font-normal text-base" style="color: #424242;">Last Name</b>
                            <input pInputText formControlName="lastName" type="text" class="inputField">
                            <small class="ng-dirty ng-invalid text-red-500"
                                *ngIf="newAdminForm.get('lastName')?.invalid && (submitted || newAdminForm.get('lastName')?.touched)">
                                Last Name is required
                            </small>
                        </div>
                        <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                            <b class="text-left font-normal text-base" style="color: #424242;">Gender</b>
                            <p-dropdown [options]="genders" formControlName="gender"
                                [ngClass]="{'ng-invalid ng-dirty' : submitted && !newAdminForm.value.gender}" optionLabel="name"
                                placeholder="Select" styleClass="dropdown selectFull" appendTo="body" class="w-full" >
                                <ng-template pTemplate="selectedItem" let-selectedOption>
                                    <div class="flex align-items-center gap-2">
                                    <div>{{ selectedOption.name }}</div>
                                    </div>
                                </ng-template>
                                <ng-template let-option pTemplate="item">
                                    <div class="flex align-items-center gap-2">
                                    <div>{{ option.name }}</div>
                                    </div>
                                </ng-template>
                            </p-dropdown>
                            <small class="ng-dirty ng-invalid text-red-500"
                                *ngIf="newAdminForm.get('gender')?.invalid && (submitted || newAdminForm.get('gender')?.touched)">
                                Select your gender
                            </small>
                        </div>
                        <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                            <b class="text-left font-normal text-base" style="color: #424242;">Email Address</b>
                            <input pInputText formControlName="email" type="text" class="inputField">
                            <small class="ng-dirty ng-invalid text-red-500"
                                *ngIf="newAdminForm.get('email')?.invalid && (submitted || newAdminForm.get('email')?.touched)">
                                Email is missing or invalid
                            </small>
                        </div>
                        <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                            <b class="text-left font-normal text-base" style="color: #424242;">Contact Number</b>
                            <input pInputText formControlName="phoneNumber" type="text" class="inputField">
                            <small class="ng-dirty ng-invalid text-red-500"
                                *ngIf="newAdminForm.get('phoneNumber')?.invalid && (submitted || newAdminForm.get('phoneNumber')?.touched)">
                                Phone Number is missing or invalid
                            </small>
                        </div>
                        <div class="col-12 sm:col-4 md:col-4 xl:col-3 flex flex-column gap-1">
                            <b class="text-left font-normal text-base" style="color: #424242;">Upload Image</b>
                            <div class="flex align-items-center gap-2 ">
                            <p-fileUpload
                            #fileUploader
                            mode="basic"

                            (onSelect)="onFileSelect($event)"
                            [auto]="false"
                            chooseLabel="Choose"
                            chooseIcon="pi pi-upload"
                            name="demo[]"
                            url="https://www.primefaces.org/cdn/api/upload.php"
                            accept=".jpg,.png,.jpeg"
                            maxFileSize="1000000" class="w-full" styleClass="upload_w" />

                            <p-button *ngIf="attachment" class="font-regular"
                            (onClick)="onFileRemoved()"
                            icon="pi pi-times"
                            styleClass="closeIcon"
                            [rounded]="true"
                            appendTo="body"
                            pTooltip="Clear image"
                            tooltipPosition="top"
                          />
                        </div>
                        </div>
                        <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                            <b class="text-left font-normal text-base" style="color: #424242;">Organization</b>
                            <input pInputText formControlName="organizationName" type="text" class="inputField">
                            <small class="ng-dirty ng-invalid text-red-500"
                                *ngIf="newAdminForm.get('organizationName')?.invalid && (submitted || newAdminForm.get('organizationName')?.touched)">
                                Organization name is required
                            </small>
                        </div>
                        <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                            <b class="text-left font-normal text-base" style="color: #424242;">Website</b>
                            <input pInputText formControlName="website" type="text" class="inputField">
                            <small class="ng-dirty ng-invalid text-red-500"
                                *ngIf="newAdminForm.get('website')?.invalid && (submitted || newAdminForm.get('website')?.touched)">
                                Website is invalid
                            </small>
                        </div>
                        <!-- <div  class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                            <b class="text-left font-normal text-base" style="color: #424242;">Admin State</b>
                            <p-dropdown  formControlName="state" [options]="adminStateOptions" styleClass="selectFull" class="w-full" optionLabel="name"
                            optionValue="value"      filterBy="name" [showClear]="true"
                            appendTo="body" placeholder="Select Admin-State">

                            </p-dropdown>
                        </div> -->

                    </div>
                </div>
                <div class="w-full flex align-items-center justify-content-center mt-3">
                    <p-button [loading]="isLoading" label="Submit" styleClass="save_btn1" type="submit"/>
                </div>
            </form>
        </div>
    </div>
  </p-dialog>
